// extracted by mini-css-extract-plugin
export default {"list":"activity-list_list__EYTkR","row":"activity-list_row__wzvfh","icon":"activity-list_icon__nGqdu","item":"activity-list_item__5aHj-","timeline":"activity-list_timeline__+Q617"};